// extracted by mini-css-extract-plugin
export default {"hero_section":"hero_hero_section__zvjif","content_hero":"hero_content_hero__6XBrZ","img_hero":"hero_img_hero__Uxm81"};